import { io } from 'socket.io-client';

// Singleton socket instance
let socket = null;

/**
 * Get or create the socket connection
 * Automatically detects whether to use localhost or network IP
 * @returns {Socket} The socket.io socket instance
 */
const socketConnection = () => {
  // Only create a new socket if one doesn't exist at all
  // Do NOT check socket.connected — the socket connects asynchronously
  // and checking .connected would cause re-creation before connection is established
  if (!socket) {
    // Get the server URL from environment or determine automatically
    const envServerUrl = process.env.REACT_APP_API_BASE;
    
    // If environment variable is set, use it (supports both localhost and network IPs)
    let serverUrl = envServerUrl || 'http://localhost:4000';
    
    // If no environment variable, check the current hostname
    if (!envServerUrl) {
      const currentHost = window.location.hostname;
      if (currentHost !== 'localhost' && currentHost !== '127.0.0.1') {
        // We're accessing from a network IP, connect to that IP
        serverUrl = `http://${currentHost}:4000`;
      }
    }
    
    // Log the URL being used for debugging
    console.log('Environment REACT_APP_API_BASE:', envServerUrl);
    console.log('Current hostname:', window.location.hostname);
    console.log('Socket connecting to:', serverUrl);
    
    socket = io(serverUrl, {
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 10000,
    });
    
    socket.on('connect', () => {
      console.log('Socket connected:', socket.id);
    });
    
    socket.on('disconnect', (reason) => {
      console.log('Socket disconnected, reason:', reason);
    });
    
    socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error.message);
    });
    
    socket.on('error', (error) => {
      console.error('Socket error:', error);
    });
  }
  
  return socket;
};

// Export a function to get a new socket instance if needed
export const getNewSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
  return socketConnection();
};

export default socketConnection;
